 $(function () {

$(document).on("click",".grid-view-btn",function(){
  $(".collection-grid .grid-item__meta").removeClass("counted"); 
});
   
// setInterval(function () {   
//     var normallen = $(".collection-grid .grid-item__meta").length;
//     var activelength = $(".collection-grid .grid-item__meta.counted").length;
//     if(normallen != activelength ){
//     if($(".collection-grid .grid-item__meta").length > 0 ){   
//       var allheight = [];
//         $(".collection-grid .grid-item__meta").each(function(){
//           var curr_hgt = $(this).height()
//             allheight.push(curr_hgt);
//             $(this).addClass("counted");       
//               });
//                 Array.prototype.max = function() {
//           return Math.max.apply(null, this);
//         };
//       $(".collection-grid .grid-item__meta").height(allheight.max()-10);
//     }
//     }
//       var normallen = $(".scrollable-grid--small .grid-item__meta").length;
//     var activelength = $(".scrollable-grid--small .grid-item__meta.counted").length;
//     if(normallen != activelength ){
//     if($(".scrollable-grid--small .grid-item__meta").length > 0 ){   
//       var allheight = [];
//         $(".scrollable-grid--small .grid-item__meta").each(function(){
//           var curr_hgt = $(this).height()
//             allheight.push(curr_hgt);
//             $(this).addClass("counted");       
//               });
//                 Array.prototype.max = function() {
//           return Math.max.apply(null, this);
//         };
//       $(".scrollable-grid--small .grid-item__meta").height(allheight.max());
//     }
//     }

 
//  }, 1000);  
   
  $(".accordion-content").css("display", "none");

 
  $(".js-accordion-title").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });
   
   
   /********* Mobile accordian *********/
    $(".accordion_head").click(function () {
        if ($('.accordion_body').is(':visible')) {
            $(".accordion_body").slideUp(300);
            $(".plusminus").text('+');
        }
        if ($(this).next(".accordion_body").is(':visible')) {
            $(this).next(".accordion_body").slideUp(300);
            $(this).children(".plusminus").text('+');
        } else {
            $(this).next(".accordion_body").slideDown(300);
            $(this).children(".plusminus").text('-');
        }
    });
  
   
   
});
  
  $('.poster_content .Product__SlideshowNavPlay').click(function(){
    $('.poster_content').hide();
    $('.video_wrap video').attr('controls',true);
	$('.video_wrap video').get(0).play()

      var video = document.getElementById('video');
    video.play();
    video.addEventListener('ended',function(){
        $('.video_wrap .poster_content').show();
       $('.video_wrap video').attr('controls',false);
      video.load();
    });
  });

$(window).scroll(function(){
if($(".usp_wrap").length >0){
  var topcart =$(".usp_wrap").offset().top - 150; 
   var showAfterc = topcart;
  if ($(this).scrollTop() > showAfterc ) { 
   $('.stickyatc').fadeIn();
  } else { 
   $('.stickyatc').fadeOut();
  }
}
 });

/*Add To Cart JS*/

/*** Variant selection on product Grid ***/
  $(document).on('click','.scrollableList_top', function () {
        $(this).next('ul').slideToggle(200);
        $('.scrollableList_top').not(this).next('ul').hide();
    });

    $(document).on('click','.scrollableList ul li', function () {
        var selectedLI = $(this).html();
     // console.log(selectedLI);
   var availability = $(this).attr('data-availability');
  var MainP=$(this).attr('data-price');
   var MainPw=$(this).attr('data-price-w') ;
  var CompareP=$(this).attr('data-compare');
   var ComparePw=$(this).attr('data-compare-w');  
  $(this).parents('.grid-item__content').find('.grid-product__price .grid-product__price--current span.money').html(MainP).attr('data-currency-inr',MainP);
  if(CompareP != ''){
   
      if($(this).parents('.grid-item__content').find('.grid-product__price .grid-product__price--original span.money').length ==0){
      $(this).parents('.grid-item__content').find('.grid-product__price').append('<span class="grid-product__price--original"><span class="money" data-currency-inr=""></span></span>')
      }
      $(this).parents('.grid-item__content').find('.grid-product__price .grid-product__price--original span.money').html(CompareP).attr('data-currency-inr',CompareP).show();
  
    var savePrice = Math.floor(((ComparePw - MainPw)*100)/ComparePw); 
   if($(this).parents('.grid-item__content').find('.grid-product__price--savings').length ==0){
      $(this).parents('.grid-item__content').find('.grid-product__price').append('<span class="grid-product__price--savings"></span>');
    }
      $(this).parents('.grid-item__content').find('.grid-product__price--savings').html(`Save ${savePrice}%`).show();
    
   }else{
   
     $(this).parents('.grid-item__content').find('.grid-product__price--savings').hide();
    
   $(this).parents('.grid-item__content').find('.grid-product__price .grid-product__price--original span.money').hide();
  }
      if(availability == 'false'){
        $(this).parents('.grid-item__content').find('.button_cart').text('Sold out').attr('disabled',true);
      }else{
        $(this).parents('.grid-item__content').find('.button_cart').text('Add To Cart').attr('disabled',false);
      }

       //var selected_option = $(this).attr('data-price') + `<span class="cprice">${$(this).attr('data-compare')}</span>`;
        $(this).parents('.scrollableList').find('.selectedOption').html(selectedLI);
        $(this).parent('ul').hide();
      var selected_value= $(this).attr('data-value');
    $(this).parents('.grid-item__content').find('.button_cart').attr('data-id',selected_value); 

    });

    $('.scrollableList').show();
    $('.select__select').hide();

  
$(document).on("click", "ul.product-option-ul .init , .dropdown-icon", function() {
  $(this).closest("ul").find('.innerLi').toggle();
});

/*** Variant selection on product Grid END HERE***/